/**
 * Converte `__iconNode` do pacote lucide-react em string SVG (innerHTML).
 * Mantém o mesmo visual dos componentes Lucide: viewBox 24×24, stroke 2, currentColor.
 *
 * @see https://lucide.dev — ISC License
 */

function escAttr(v) {
  return String(v ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

/**
 * @param {Array<[string, Record<string, string>]>} nodes - formato __iconNode do Lucide
 * @param {{ width?: number, height?: number, className?: string }} [opts]
 */
export function lucideNodesToSvgString(nodes, opts = {}) {
  const w = opts.width ?? 16;
  const h = opts.height ?? 16;
  const className = opts.className ? ` class="${escAttr(opts.className)}"` : '';
  const inner = (nodes || []).map(([tag, attrs]) => {
    const { key: _omitKey, ...rest } = attrs || {};
    const attrStr = Object.entries(rest)
      .map(([k, v]) => `${k}="${escAttr(v)}"`)
      .join(' ');
    return `<${tag} ${attrStr}/>`;
  }).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"${className} aria-hidden="true">${inner}</svg>`;
}
